import React from "react";
import { Text, Flex, Box } from "shipnow-mercurio";
import { formatCurrency } from "../../../../../../common/utils/currency.utils";
import PropTypes from "prop-types";

const DEFAULT_PROPS = {
  carrier: null,
};

export const EstimatedShippingPrice = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  if (!attrs.carrier?.name) {
    return null;
  }

  return (
    <Box margin="b-24">
      <Text size="title" margin="b-16">
        Precio del servicio
      </Text>
      <Text size="bodySemibold" margin="b-4">
        {attrs.carrier.name}
      </Text>
      <Flex justifyContent="space-between" margin="b-4">
        <Text>Valor estimado</Text>
        <Text size="bodySemibold">
          {formatCurrency(attrs.carrier.tax_price)}
        </Text>
      </Flex>
      <Flex justifyContent="space-between" margin="b-4">
        <Text size="captionRegular">
          Sujeto a cambios cuando pesemos el pedido.
        </Text>
        <Text size="captionRegular">
          ({formatCurrency(attrs.carrier.price)} + IVA 21%)
        </Text>
      </Flex>
    </Box>
  );
};

EstimatedShippingPrice.propTypes = {
  carrier: PropTypes.object,
};
